import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './utilities/http'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <App />
  </React.Fragment>
);
